import { isJSON } from "utils/isJson";

export const isFraRole = () => {
  let LoggedInUser = localStorage.getItem("loggedInUser");
  try {
    let userObject = JSON.parse(LoggedInUser);

    if (userObject && userObject.group_id === "fra") {
      return true;
    }
  } catch (e) {}

  return false;
};

export const isUserEmailInList = (emailList) => {
  let user = isJSON(localStorage.getItem("loggedInUser"));
  if (user && emailList.includes(user.email)) return true;
  return false;
};

export const isSuperAdminRole = () => {
  let user = isJSON(localStorage.getItem("loggedInUser"));
  if (user && user.isAdmin && user.email === "superadmin@timps.com") return true;
  return false;
};

export const getLoggedInUser = () => {
  let LoggedInUser = localStorage.getItem("loggedInUser");
  try {
    let userObject = JSON.parse(LoggedInUser);

    if (userObject && userObject.group_id) {
      return userObject;
    }
  } catch (e) {}

  return false;
};



// WEBPACK FOOTER //
// ./src/components/MainPage/UserInfo.js